import { types, actions } from './requests'
export const GETPRODUCT_TYPES = {
    ...types('GETPRODUCT'),
}
export const GETPRODUCT_ACTIONS = {
    ...actions('GETPRODUCT'),
}
